import { Switch } from '@headlessui/react';
import { cn } from '../../../lib/styles';
import type { ToggleProps } from './types';

export function Toggle({ checked, disabled, onChange }: ToggleProps) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={cn(
        'relative inline-flex h-6 w-11 shrink-0 rounded-full transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-spark-purple focus:ring-offset-2',
        checked ? 'bg-spark-purple' : 'bg-gray-200',
        disabled
          ? 'cursor-not-allowed border-2 border-gray-300 bg-gray-300'
          : 'cursor-pointer border-2 border-transparent',
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          'inline-block size-5 transform rounded-full shadow-xs ring-0 transition duration-200 ease-in-out',
          checked ? 'translate-x-5' : 'translate-x-0',
          disabled ? 'bg-gray-400' : 'bg-white',
        )}
      />
    </Switch>
  );
}
